module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbb472c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Console.vue
// module id = 2650
// module chunks = 1